module.exports = __webpack_public_path__ + "static/media/how-does-it-work-en.3fb0a362.svg";